import AssignedReviewTaskPage from '../global-view/AssignedReviewTaskPage';

export default function AssignedReviewQcTaskPage() {
  return <AssignedReviewTaskPage />;
}
